/**
 * O SUJEITO da política de uma busca: UM viajante, sempre um id da lista
 * vigente — mantém o atual se ainda presente; senão o solicitante (se viaja) ou
 * o 1º. A mesma régua no aéreo, no hotel e no ônibus: o requester pode reservar
 * só para terceiros, e aí a política é de quem viaja, não dele. `undefined` só
 * com a lista vazia.
 */
export function resolvePolicyTraveler(
  travelers: readonly { readonly id: string }[],
  current: string | undefined,
  requesterId: string | undefined,
): string | undefined {
  if (current && travelers.some((traveler) => traveler.id === current)) return current;
  if (requesterId && travelers.some((traveler) => traveler.id === requesterId)) return requesterId;
  return travelers[0]?.id;
}
